module.exports = __webpack_public_path__ + "static/img/18.51cb919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/18.jpg
// module id = 289
// module chunks = 0